/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit GraphIcon/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function GraphIcon({
  children,
  viewPath = "/DesignSystem/Svgs/GraphIcon",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 32,
  height = 32,
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill = "none",
  stroke = "#474747"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="GraphIcon.Svg"
  data-view-path={viewPath}
 viewBox="0 0 32 32"
 overflow="visible"
 style={{'--as-1-XVwm1': alignSelf,'--mt-2-XVwm1': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-XVwm1': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-XVwm1': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-XVwm1': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-XVwm1': opacity,'--w-10-XVwm1': typeof width === 'number' ? `${width}px` : width,'--h-11-XVwm1': typeof height === 'number' ? `${height}px` : height,'--a-7-XVwm1': isAnimated ? animation : "none",'--sd-8-XVwm1': isAnimated ? strokeDashoffset : 0,'--sd-9-XVwm1': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="GraphIcon.SvgPath"
  data-view-path={viewPath}
 strokeWidth={3}
 strokeLinejoin="round"
 strokeMiterlimit={10}
 d="M2.9 25.5h26.2M3.5 18.5s1.7-5.7 5.9-5.7c3.1 0 3.1 2.8 6.5 2.8 4.5 0 4.4-9 13.1-9"
 style={{'--f-12-XVwm1': fill,'--s-13-XVwm1': stroke}}
 className={`views-block ${styles.SvgPath}`}
/>
</svg>
{children}
</React.Fragment>)
}